<div id="anchor-publication" class="container-fluid block mt-5">
    <div class="row box">
        <div class="col-10 offset-1 col-lg-8 col-xxl-6 offset-lg-2 offset-xxl-3">
            <h1 class="title">O publikacji</h1>
            <p
                    data-aos="fade-right"
                    data-aos-offset="300"
                    class="description col-12 my-4"
            >
                „Statut nieumarły” to unikatowa pozycja na rynku. To przede wszystkim wzorcowy statut, który będzie można odpowiednio dostosować do potrzeb konkretnej szkoły. Zawarliśmy w nim tylko te postanowienia, które są wymagane prawem, dzięki czemu statut jest zwarty, nieobszerny i przejrzysty. Sam wzór statutu uzupełniliśmy o komentarz, w którym objaśniamy, dlaczego dane postanowienia w statucie muszą się znaleźć, wyjaśniając przy tym, jakich błędów należy unikać tworząc konkretne przepisy.
            </p>
            <p
                    data-aos="fade-right"
                    data-aos-offset="300"
                    class="description col-12 my-4"
            >
                Zaproponowane przez nas rozwiązania w zakresie oceniania są innowacyjne i niespotykane na szerszą skalę. Pokazujemy, jak wdrożyć w szkole zgodnie z prawem ocenianie bieżących bez tradycyjnych stopni w skali 1-6, i jak uczyć uczennice i uczniów odpowiedzialności za ich rozwój i proces edukacyjny. W zakresie oceny zachowania prezentujemy model oparty nie na systemie punktowym czy uwagach wpisywanych do dziennika, ale na wspieraniu uczniów w ich dojrzewaniu, socjalizacji i nabywaniu kompetencji społecznych.
            </p>
            <p
                    data-aos="fade-right"
                    data-aos-offset="300"
                    class="description col-12 my-4"
            >
                Nasza publikacja jest dostępna bezpłatnie, a udostępniamy ją na licencji Creative Commons (CC BY-NC-SA 4.0).
            </p>
        </div>
    </div>
</div>

<style>
    #anchor-publication {
        overflow-x: hidden;
    }

    .box {
        margin: 0 !important;
    }

    .block {
        display: flex;
        align-items: center;
        min-height: 100vh;
        padding: 0 !important;
        overflow-y: visible;
    }

    .title {
        font-family: "Montserrat";
        font-style: normal;
        font-weight: bold;
        font-size: 36px;
    }

    .description {
        font-family: "Work Sans";
        font-size: 14px;
        line-height: 16px;

        color: #425466;
    }
</style>
